module.exports = __webpack_public_path__ + "static/img/csn2.be80b989.png";